export default "__VITE_ASSET__DxraZkdr__"